export const environment = {
  production: false,
  graphqlEndpoint: 'https://6i4svvfihbcvnmfokmrz45sfba.appsync-api.eu-central-1.amazonaws.com/graphql',
  region: 'eu-central-1',
  amplifyConfiguration: {
    userPoolId: 'eu-central-1_oDxPHJHaH',
    userPoolClientId: '2hdqj66j1akolnc80hdqk1brf3',
    oauth: {
      domain: 'insolution-workshop-auth-domain-acc.auth.eu-central-1.amazoncognito.com',
      scopes: ['email', 'openid', 'profile'],
      redirectSignIn: ['https://d21hfz9arzhm50.cloudfront.net/'],
      redirectSignOut: ['https://d21hfz9arzhm50.cloudfront.net/'],
      responseType: 'code',
    },
  },
  rumConfiguration: {
    appMonitorId: 'd9de2769-1e7a-4379-bfe6-4bf4061cfaa1',
    identityPoolId: 'eu-central-1:760fec9a-6161-41c6-a859-219967d5fcee',
    region: 'eu-central-1',
    appVersion: 'web',
    sampleRate: 1,
  },
};
